import React, { Component } from "react"
import moment from "moment"

import genericVisualizationScene, {
    genericBarPieScene,
    genericLineScene,
    genericMapScene,
} from "search-new/containers/Visualization/VisualizationScene/VisualizationScenes"
import {
    ArticleCountryFilter,
    ArticleOutletFilter,
    ArticlePressFilter,
    ArticleProjectFilter,
    ArticlePublishDatePickerEndNoFutureFilter,
    ArticlePublishDatePickerStartNoFutureFilter,
    ArticleSourceTypeFilter,
    ArticleStateFilter,
} from "shared/search/containers/Filter/ArticleFilters"

import { federalMapConfig, euMapConfig } from "search-new/components/Visualization/VisualizationWrappers/MapConfigs"
import { euRegions, stateRegions } from "shared/imports/regionConstants"

export class ArticleMapScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "articleMapScene",
        filterId: ArticleStateFilter.defaultProps.uniqueFilterId,
        label: "Map",
        icon: "fa-location-arrow",
        configs: federalMapConfig,
        regions: stateRegions,
    }

    render() {
        return genericMapScene(this.props)
    }
}

export class ArticleEUMapScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "euMapScene",
        filterId: ArticleCountryFilter.defaultProps.uniqueFilterId,
        label: "Map",
        icon: "fa-location-arrow",
        configs: euMapConfig,
        regions: euRegions,
    }

    render() {
        return genericMapScene(this.props)
    }
}

export class ArticleStateBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "articleStateBarPieScene",
        filterId: ArticleStateFilter.defaultProps.uniqueFilterId,
        variableRequestKey: "stateFrequency",
        label: "States",
        icon: "fa-map-marker",
        regions: stateRegions,
        sidebarTableLabel: "Mentions by State",
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

export const ArticleInIssuesBarPieScene = (props) => genericBarPieScene(props)
ArticleInIssuesBarPieScene.defaultProps = {
    uniqueVizSceneId: "articleInIssuesBarPieScene",
    filterId: ArticleProjectFilter.defaultProps.uniqueFilterId,
    variableRequestKey: "inIssueFrequency",
    label: "Issues",
    icon: DjangIO.app.models.QuorumDataType.issue_management.icon,
    sidebarTableLabel: "Articles tagged to Issue",
}

export class ArticleSourceTypeBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "articleSourceTypeBarPieScene",
        filterId: ArticleSourceTypeFilter.defaultProps.uniqueFilterId,
        variableRequestKey: "typeFrequency",
        label: "Types",
        icon: "fa-book",
        sidebarTableLabel: "Mentions by Article Type",
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

export class ArticleTrendsScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "ArticleTrendsScene",
        dateStartId: ArticlePublishDatePickerStartNoFutureFilter.defaultProps.uniqueFilterId,
        dateEndId: ArticlePublishDatePickerEndNoFutureFilter.defaultProps.uniqueFilterId,
        label: "Trends",
        icon: "fa-line-chart",
        sidebarTableLabel: "Date Created",
        visualizationFilterValues: { start: moment(), end: moment() },
    }

    render() {
        return genericLineScene(this.props)
    }
}

export class ArticleOutletBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "articleOutletBarPieScene",
        filterId: ArticleOutletFilter.defaultProps.uniqueFilterId,
        variableRequestKey: "outletFrequency",
        label: "Outlets",
        icon: "fa-building",
        sidebarTableLabel: "Articles by Source Outlet",
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

export class ArticlePressBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "articlePressBarPieScene",
        filterId: ArticlePressFilter.defaultProps.uniqueFilterId,
        variableRequestKey: "pressContactFrequency",
        label: "Authors",
        icon: "fa-microphone",
        sidebarTableLabel: "Articles by Author",
    }

    render() {
        return genericBarPieScene(this.props)
    }
}
